export const UPLOAD_PROPS = {
  buttonText: 'Add a side photo',
  reviewModal: {
    list: [
      {
        attribute: "Your dog's entire body is visible",
      },
      {
        attribute: 'This photo is a side view',
      },
      {
        attribute: 'They are not eating in the photo',
      },
    ],
    listTitle: 'PLEASE DOUBLE CHECK:',
    primaryButtonText: 'Submit a side photo',
    secondaryButtonText: 'Pick a different photo',
    title: 'Is this a side photo?',
  },
  tips: {
    title: 'Tips For Taking the Pic',
    cards: [
      {
        content:
          'Take photo from the side while your pup is standing so their waist and chest are visible.',
        icon: {},
        title: '  ',
      },
      {
        content: 'Make sure your dog is not eating in the photo.',
        icon: {},
        title: '',
      },
    ],
  },
  stepResult: {
    title: 'Unable to assess',
    description: 'Please update another picture',
    image: {
      src: '',
      width: 20,
      height: 20,
      alt: 'image',
    },
    ctaText: 'Choose a new photo',
  },
};

export const PHOTO_UPLOAD_ERROR_MSG =
  'Photo failed to upload. Please try again.';
